import e from "@dialpad/dialtone-tokens/layered/themes/tokens-131-colors.css?inline";
//#region themes/131.js
var t = { brand: {
	css: e,
	name: "131"
} };
//#endregion
export { t as default };
